import HojasQuirurgicasService from "../../../services/hospitalizacion/HojasQuirurgicasService";
import AutorizacionService from "../../../services/autorizacion/AutorizacionService";
import ResponseCode from "../../../services/ResponseCode";
import { MODALIDADES_PSS } from "./HospitalizacionConstant";

export const construirValidacionData = (
  pacienteData,
  authUserData,
  empresa,
  correoValidacion,
  comentarioValidacion = "Validación creada automáticamente"
) => {
  return {
    origen: "WEBSALUD",
    ano: pacienteData?.ano,
    compania: empresa.CODIGO,
    ramo: pacienteData?.claveRamo,
    secuencialPoliza: pacienteData?.secuencialPoliza,
    plan: pacienteData?.clavePlan,
    codigoAsegurado: pacienteData.codigoPersonaHospitalizada,
    dependienteAsegurado:
      pacienteData?.tipoPersonaHospitalizada === "ASEGURADO" ? 0 : pacienteData.secuenciaDependiente,
    numeroIngreso: pacienteData?.secuencial.toString(),
    fechaIngreso: pacienteData?.fechaIngreso,
    fechaEgreso: pacienteData?.fechaSalida,
    fechaTransaccion: new Date().toISOString(),
    horaTransaccion: new Date().toISOString(),
    codigoMedicoIngreso: authUserData?.prestador?.codigo,
    codigoDiagnosticoIngreso: "DX1",
    estatusValidacion: 1,
    codigoPss: pacienteData?.claveAfiliadoClinica,
    encuestaCsat: "N",
    encuestaCes: "N",
    tipoReclamante: authUserData?.prestador?.tipoPss,
    correoPss: correoValidacion,
    usuarioCreacion: authUserData?.prestador?.nombre,
    fechaModificacion: new Date().toISOString(),
    usuarioModifica: authUserData?.prestador?.nombre,
    comentarioValidacion: comentarioValidacion,
    observacionSpool: "Sin observaciones",
  };
};

export const verificarCirugiaLiberada = async (codigoCobertura) => {
  try {
    const params = {
      cobertura: codigoCobertura,
      pagina: 1,
      tamanoPagina: 10,
    };

    const respuesta = await AutorizacionService.getCirugiasLiberadas(params);

    if (respuesta?.data && respuesta.data.length > 0) {
      const existeCobertura = respuesta.data.some(
        (item) => item.cobertura === codigoCobertura
      );
      return existeCobertura;
    }

    return false;
  } catch (error) {
    console.error("Error al verificar cirugía liberada:", error);
    return false;
  }
};

export const verificarCoberturasLiberadas = async (coberturas) => {
  const coberturasLiberadas = [];
  const codigosCoberturas = coberturas
    .map((c) => c?.cobertura?.cobertura)
    .filter(Boolean);

  const verificaciones = await Promise.all(
    codigosCoberturas.map(async (codigoCobertura) => {
      const esLiberada = await verificarCirugiaLiberada(codigoCobertura);
      return { codigoCobertura, esLiberada };
    })
  );

  verificaciones.forEach(({ codigoCobertura, esLiberada }) => {
    if (esLiberada) {
      const cobertura = coberturas.find(
        (c) => c?.cobertura?.cobertura === codigoCobertura
      );
      if (cobertura) {
        coberturasLiberadas.push(cobertura);
      }
    }
  });

  return coberturasLiberadas;
};

export const construirPayloadCobertura = (
  cobertura,
  secuencial,
  lineaNo,
  tipoReclamante,
  esHibrido,
  esCirugiaLiberada = false
) => {
  const modalidadCobertura = esHibrido
    ? cobertura?.modalidadPss || tipoReclamante
    : tipoReclamante;
  const esPaquete = modalidadCobertura === MODALIDADES_PSS.PAQUETE;

  const payload = {
    Secuencial: secuencial,
    LineaNo: lineaNo,
    TipoServicio: 2,
    TipoCobertura: 511,
    Cobertura: cobertura?.cobertura.cobertura,
    EspecialidadMedico: cobertura?.medico?.codigoEspecialidad?.toString() || "",
    CodigoMedico: esPaquete ? "0" : cobertura?.medico.codigo,
    Estatuscobertura: esCirugiaLiberada ? 2 : 1,
    NombreMedico: cobertura?.medico?.nombre || "",
  };

  return payload;
};

export const construirPayloadAnexo = (
  resultado,
  archivo,
  secuencial,
  lineaNo,
  coberturaReclamada
) => {
  return {
    secuencial: secuencial,
    lineaNo: lineaNo,
    descripcionArchivo:
      resultado?.metadata?.OriginalFileName || archivo?.name || "",
    rutaArchivo: resultado?.directLink || "",
    tamanoArchivo: resultado?.length || archivo?.size || 0,
    estadoEnvio: "PENDIENTE",
    coberturaReclamada: coberturaReclamada,
  };
};

export const procesarEnvioCoberturas = async (
  coberturasParaEnviar,
  secuencial,
  tipoReclamante,
  coberturasEnviadas
) => {
  let todasLasCoberturasExitosas = true;
  const erroresCoberturas = [];
  const coberturasDuplicadas = [];
  const nuevasCoberturasEnviadas = new Set(coberturasEnviadas);
  const esHibrido = tipoReclamante === MODALIDADES_PSS.HIBRIDO;

  const coberturasLiberadas = await verificarCoberturasLiberadas(
    coberturasParaEnviar
  );
  const codigosCoberturasLiberadas = new Set(
    coberturasLiberadas.map((c) => c?.cobertura?.cobertura).filter(Boolean)
  );

  for (let i = 0; i < coberturasParaEnviar.length; i++) {
    const cobertura = coberturasParaEnviar[i];
    const codigoCobertura = cobertura?.cobertura?.cobertura;
    const esCirugiaLiberada = codigosCoberturasLiberadas.has(codigoCobertura);

    const payloadCobertura = construirPayloadCobertura(
      cobertura,
      secuencial,
      i + 1,
      tipoReclamante,
      esHibrido,
      esCirugiaLiberada
    );

    try {
      const respuestaCobertura =
        await HojasQuirurgicasService.registrarCobertura({
          requestData: payloadCobertura,
          requestHeaders: {},
        });
      const codigoRespuesta = respuestaCobertura?.respuesta?.codigo;

      if (codigoRespuesta === ResponseCode.OK.code) {
        if (cobertura?.id) {
          nuevasCoberturasEnviadas.add(cobertura.id);
        }
      } else {
        const mensajeError =
          respuestaCobertura?.respuesta?.mensaje ||
          "Error desconocido al registrar cobertura";

        if (codigoRespuesta === ResponseCode.SERVER_ERROR.code) {
          const error = new Error(mensajeError);
          error.codigo = codigoRespuesta;
          throw error;
        }

        if (codigoRespuesta === ResponseCode.BAD_REQUEST.code) {
          coberturasDuplicadas.push({
            id: cobertura?.id,
            codigoCobertura: cobertura?.cobertura?.cobertura || "",
            nombreCobertura: cobertura?.cobertura?.nombreCobertura || "",
          });
        }

        if (
          cobertura?.id &&
          codigoRespuesta !== ResponseCode.BAD_REQUEST.code
        ) {
          nuevasCoberturasEnviadas.add(cobertura.id);
        }
      }
    } catch (error) {
      console.error(`Error al registrar cobertura ${i + 1}:`, error);
      if (error?.codigo === 500 || (!error?.codigo && error?.message)) {
        todasLasCoberturasExitosas = false;
        erroresCoberturas.push({
          cobertura: i + 1,
          error: error.message || "Error desconocido",
        });
      }
    }
  }

  const coberturasDuplicadasIds = new Set(
    coberturasDuplicadas.map((c) => c.id).filter(Boolean)
  );

  return {
    todasLasCoberturasExitosas,
    erroresCoberturas,
    nuevasCoberturasEnviadas,
    coberturasDuplicadas,
    coberturasDuplicadasIds,
    coberturasLiberadas,
  };
};

export const procesarEnvioAnexos = async (
  archivos,
  secuencial,
  archivosEnviados
) => {
  let todosLosAnexosExitosos = true;
  const erroresAnexos = [];
  const nuevosArchivosEnviados = new Set(archivosEnviados);

  for (let i = 0; i < archivos.length; i++) {
    const archivo = archivos[i];
    const archivoId = archivo?.id;
    const archivoName = archivo?.name || archivo?.file?.name;
    const coberturaReclamada = archivo?.codigoCobertura || "";

    try {
      const resultado = await HojasQuirurgicasService.registrarImagenBlobStorage(
        {
          file: archivo?.file || archivo,
          metadata: JSON.stringify({
            OriginalFileName: archivo?.name || `archivo_${i + 1}`,
            UserCreated: "usrValidacionHojaQX",
          }),
          requestHeaders: {},
        }
      );

      const payloadAnexo = construirPayloadAnexo(
        resultado,
        archivo,
        secuencial,
        i + 1,
        coberturaReclamada
      );

      const respuestaAnexo = await HojasQuirurgicasService.registrarAnexo({
        requestData: payloadAnexo,
        requestHeaders: {},
      });

      if (respuestaAnexo?.respuesta?.codigo !== ResponseCode.OK.code) {
        const codigoError = respuestaAnexo?.respuesta?.codigo;
        const mensajeError =
          respuestaAnexo?.respuesta?.mensaje ||
          "Error desconocido al registrar anexo";

        if (codigoError === 500) {
          const error = new Error(mensajeError);
          error.codigo = codigoError;
          throw error;
        }
        if (archivoId) {
          nuevosArchivosEnviados.add(archivoId);
        }
        if (archivoName) {
          nuevosArchivosEnviados.add(archivoName);
        }
      } else {
        if (archivoId) {
          nuevosArchivosEnviados.add(archivoId);
        }
        if (archivoName) {
          nuevosArchivosEnviados.add(archivoName);
        }
      }
    } catch (error) {
      console.error(`Error al procesar anexo ${i + 1}:`, error);
      if (error?.codigo === 500 || (!error?.codigo && error?.message)) {
        todosLosAnexosExitosos = false;
        erroresAnexos.push({
          anexo: i + 1,
          nombre: archivo?.name || `archivo_${i + 1}`,
          error: error.message || "Error desconocido",
        });
      }
    }
  }

  return {
    todosLosAnexosExitosos,
    erroresAnexos,
    nuevosArchivosEnviados,
  };
};

export const construirMensajeResultado = (
  todoExitoso,
  coberturasParaEnviar,
  archivos,
  erroresCoberturas,
  erroresAnexos
) => {
  let titulo = "";
  let mensaje = "";
  let tipo = "success";

  if (todoExitoso) {
    tipo = "success";
    titulo = "Envío exitoso";
    const mensajes = [];
    if (coberturasParaEnviar.length > 0) {
      mensajes.push(
        `${coberturasParaEnviar.length} cobertura${
          coberturasParaEnviar.length > 1 ? "s" : ""
        }`
      );
    }
    if (archivos.length > 0) {
      mensajes.push(
        `${archivos.length} anexo${archivos.length > 1 ? "s" : ""}`
      );
    }
    mensaje = `Se enviaron correctamente ${mensajes.join(" y ")}.`;
  } else {
    tipo = "error";
    titulo = "Error al enviar datos";
    const mensajes = [];

    if (coberturasParaEnviar.length > 0) {
      const coberturasExitosas =
        coberturasParaEnviar.length - erroresCoberturas.length;
      if (coberturasExitosas === coberturasParaEnviar.length) {
        mensajes.push(
          `${coberturasParaEnviar.length} cobertura${
            coberturasParaEnviar.length > 1 ? "s" : ""
          } enviadas correctamente`
        );
      } else {
        mensajes.push(
          `${coberturasExitosas} de ${coberturasParaEnviar.length} cobertura${
            coberturasParaEnviar.length > 1 ? "s" : ""
          } enviadas`
        );
      }
    }

    if (archivos.length > 0) {
      const anexosExitosos = archivos.length - erroresAnexos.length;
      if (anexosExitosos === archivos.length) {
        mensajes.push(
          `${archivos.length} anexo${
            archivos.length > 1 ? "s" : ""
          } enviados correctamente`
        );
      } else {
        mensajes.push(
          `${anexosExitosos} de ${archivos.length} anexo${
            archivos.length > 1 ? "s" : ""
          } enviados`
        );
      }
    }

    mensaje = mensajes.join(". ") + ".";
  }

  return {
    tipo,
    titulo,
    mensaje,
    detalles: [...erroresCoberturas, ...erroresAnexos],
  };
};
